(function () {
  'use strict';

  addEventListener('DOMContentLoaded', () => {
    if (customElements.get('cos-countdown')) return;  

    class CosCountdown extends HTMLElement {
      connectedCallback() { 
        const settings = this.dataset.settings ? JSON.parse(this.dataset.settings) : {};
        const launchDate = new Date(`${settings.dateTime}`);

        const interval = setInterval(() => {
          const now = new Date().getTime();
          const distance = launchDate - now;      
          
          const counters = {
            days: Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((distance % (1000 * 60)) / 1000)
          };

          for (const [key, value] of Object.entries(counters)) {
            const el = this.querySelector(`[data-update=${key}]`);
            if (!el) return;

            el.textContent = value;
          }

          if (distance < 0) {
            clearInterval(interval);
            this.innerHTML = `<div class="h2">${settings.launchedMessage}</div>`;
          }
        }, 1000);
      }
    }

    customElements.define('cos-countdown', CosCountdown);
  });
})();